import { FunctionComponent, useState, useEffect, useCallback } from 'react'
import {
  AlertTitle,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'
import {
  customEvent,
  Translation,
  useNavigateWithPreview,
} from '@dxp-module/common'
import { useLocation } from 'react-router-dom'
import { tokenService } from '@dxp-module/login'
import CancelIcon from '@mui/icons-material/Cancel'
import GeneralEvents from '../../constants/GeneralEvents'
import ROUTES from '../../enum/Routes'
import sessionErrorModalStyles from './sessionErrorModal.styles'

// TODO fix react hook linting error exhaustive-deps
/* eslint-disable react-hooks/exhaustive-deps */
const SessionErrorModal: FunctionComponent = () => {
  const [showModal, setShowModal] = useState(false)
  const location = useLocation()
  const styles = sessionErrorModalStyles()
  const handleSessionEvent = useCallback(() => {
    setShowModal(true)
  }, [])
  const hideModalRoutes = [
    ROUTES.INDEX,
    ROUTES.MYACCOUNT_SET_PASSWORD,
    ROUTES.MYACCOUNT_FORGOT_PASSWORD,
    ROUTES.MYACCOUNT_LOGIN,
    ROUTES.MYACCOUNT_SIGNUP,
  ] as string[]

  const navigateWithPreview = useNavigateWithPreview()

  useEffect(() => {
    if (!hideModalRoutes.includes(location.pathname)) {
      customEvent.listen(GeneralEvents.SESSION_ERROR, handleSessionEvent)
      return () => {
        customEvent.removeListener(
          GeneralEvents.SESSION_ERROR,
          handleSessionEvent
        )
      }
    }
  }, [location.pathname, handleSessionEvent])

  const onConfirmClick = () => {
    tokenService.removeCurrentToken()
    setShowModal(false)
    navigateWithPreview(ROUTES.MYACCOUNT_LOGIN)
  }

  if (showModal) {
    return (
      <Dialog
        fullWidth
        maxWidth="xs"
        open={true}
        onClose={onConfirmClick}
        data-test="myAccount:sessionError"
        classes={{
          paper: styles.container,
        }}
      >
        <DialogActions className={styles.closeContainer}>
          <CancelIcon
            data-test="myAccount:sessionError:close"
            onClick={onConfirmClick}
            className={styles.close}
            sx={{ width: '1.1em', height: '1.1em' }}
          />
        </DialogActions>
        <DialogTitle>
          <AlertTitle data-test="myaccount:sessionModalTitle">
            <Typography className={styles.title}>
              <Translation id="trans__myaccount__session_modal__title" />
            </Typography>
          </AlertTitle>
        </DialogTitle>
        <DialogContent
          className={styles.content}
          data-test="myaccount:sessionModalContent"
        >
          <Typography>
            <Translation id="trans__myaccount__session_modal__description" />
          </Typography>
        </DialogContent>
        <DialogActions className={styles.actionsRoot}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            data-test="myAccount:sessionError:confirm"
            onClick={onConfirmClick}
            className={styles.button}
          >
            <Translation
              id="trans__myaccount__session_modal__submit_cta"
              component="Typography"
              componentProps={{ variant: 'button' }}
            />
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  return null
}

export default SessionErrorModal
